declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

const push = function (...rest: unknown[]): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(...rest);

  if (import.meta.env.VITE_ENV === 'dev') console.log('GTM.push', ...rest);
};

export default {
  push,
};
